import {useQuery} from "react-query";
import axios from "services/axios";
import {useState} from "react";

export const QUERY = "medicalRecord";

export const fetchMedicalRecord = medicalRecordId => {
	return axios.get(`/medical_record/${medicalRecordId}`).then(res => res.data);
};

export function useDetailMedicalRecord(medicalRecordId) {
	return useQuery({
		queryKey: medicalRecordId && [QUERY, medicalRecordId],
		queryFn: key => fetchMedicalRecord(medicalRecordId),
		refetchOnMount: false,
		refetchOnWindowFocus: false,
		enabled: !!medicalRecordId,
	});
}

async function getMedicalRecords(filter) {
	const {data} = await axios.get(`/medical_record`, {params: filter});

	return data;
}

export function useMedicalRecords(defaultFilter = {}) {
	const [filterMedicalRecords, setFilterMedicalRecords] = useState({
		page: 1,
		search: null,
		limit: 10,
	});
	const fallback = [];
	const {
		data = fallback,
		isLoading,
		isError,
		error,
	} = useQuery(["medicalRecords", filterMedicalRecords, defaultFilter], async () =>
		getMedicalRecords({...filterMedicalRecords, ...defaultFilter}),
	);

	return {data, isLoading, isError, error, filterMedicalRecords, setFilterMedicalRecords};
}
